import React from 'react';
import { StyleSheet } from 'react-native';

import { theme } from '@garnish/constants';
import { FadeView } from '@garnish/core';

// ─────────────────────────────────────────────────────────────────────────────

export const CustomizationLoadingOverlay = (props: Props) => {
  const { show } = props;

  return <FadeView show={show} style={styles.container} />;
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    ...StyleSheet.absoluteFill,
    backgroundColor: theme.colors.OPACITY.WHITE.DARKER,
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = {
  show: boolean;
};
